import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './stores/store'
import './index.css';
import Nav from './Components/shared/Nav';
import Home from './pages/Home';
import About from './pages/About'
import Articles from './pages/Articles'
import Project from './pages/Projects'
import Footer from './Components/shared/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <div className='flex flex-col min-h-screen bg-neutral-100'>
      <Nav />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/projects" element={<Project />} />
        </Routes>
      </BrowserRouter>
      <div class="mt-auto">
        <Footer />
      </div>
    </div>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
